// @flow
import { reject, resolve } from 'redux-optimist-promise';
import { get } from 'lodash';

import createReducer from 'Store/utils/createReducer';

import {
  type PriceOfStayData,
  type PriceOfStayError,
  type PriceOfStayResponse,
} from 'Store/price-remote/price-of-stay/priceOfStay.helper';
import { PRICE_OF_STAY_REQUEST, RESET_PRICE_OF_STAY } from 'Store/price-remote/constants';

type PriceOfStayRequestResolvedAction = OptimisticResolvedAction<PriceOfStayResponse>;

export type PriceOfStayState = {
  isLoading: boolean,
  data: ?PriceOfStayData,
  error: ?PriceOfStayError,
  lastRequestId: number,
};

const initialState: PriceOfStayState = {
  isLoading: true,
  data: null,
  error: null,
  lastRequestId: -1,
};

export const priceOfStayReducer: PriceOfStayState = createReducer(initialState, {
  [PRICE_OF_STAY_REQUEST](
    state: PriceOfStayState,
    action: PriceOfStayRequestResolvedAction,
  ): PriceOfStayState {
    return {
      ...state,
      isLoading: true,
      lastRequestId: get(action, 'optimist.id', -1),
    };
  },
  [resolve(PRICE_OF_STAY_REQUEST)](
    state: PriceOfStayState,
    action: PriceOfStayRequestResolvedAction,
  ): PriceOfStayState {
    // If there is another request in progress
    if (get(action, 'optimist.id', -1) !== state.lastRequestId) {
      return state;
    }

    const { priceOfStay } = action.payload;

    if (priceOfStay && priceOfStay.errors) {
      return {
        ...state,
        isLoading: false,
        data: null,
        error: priceOfStay.errors,
      };
    }

    return {
      ...state,
      isLoading: false,
      data: priceOfStay,
      error: null,
    };
  },
  [reject(PRICE_OF_STAY_REQUEST)](state: PriceOfStayState): PriceOfStayState {
    return {
      ...state,
      isLoading: false,
    };
  },
  [RESET_PRICE_OF_STAY](state: PriceOfStayState): PriceOfStayState {
    return {
      ...state,
      error: null,
      data: null,
    };
  },
});
